import { Flex, Skeleton } from "antd";
import React from "react";
import { useHistory } from "react-router-dom";

import { useRedirect } from "@Roo/RegistrationNew/Components/Common/hooks/useRedirect";

import { useRegistrationProgress } from "./Components/Common/hooks/useRegistrationProgress";
import { REGISTRATION_PATHS } from "./Components/Common/service";

export const RegistrationContinue = () => {
  const history = useHistory();
  const progress = useRegistrationProgress();

  const { redirectToVetPreferences } = useRedirect();

  if (progress === "Error") {
    history.push(REGISTRATION_PATHS["Landing"]);
  } else if (progress === "HighCommitment") {
    redirectToVetPreferences({ highCommitment: true });
  } else if (progress !== "Loading") {
    history.push(REGISTRATION_PATHS[progress]);
  }

  return (
    <Flex className="p-5">
      <Skeleton />
    </Flex>
  );
};
